import React from "react";
import OPOnlineIframe from "../../../iframe-component/operation-online/OPOnIframe";

const AddOnlineEmployeeIframe = ({ path }) => {
  return <OPOnlineIframe path="/online-pay/employee/create" statePath={path} />;
};

export default React.memo(AddOnlineEmployeeIframe);
